import { trackEvent, trackAccountCreatedEvent, trackEventForPartner } from 'src/utils/analytics';
import { clearTrackingSession, trackFootfallEvent } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import { getBranch } from 'src/utils/cookie';

export default store => next => action => {
  const result = next(action);
  const state = store.getState();
  switch (action.type) {
    case 'LIKE_POST_SUCCESS':
      if (action.isLiked) {
        trackEvent('Activity', 'Recommended', action.communitySlug);
      }
      break;
    case 'POST_RESPOND_SUCCESS':
      trackEvent('Content', 'Reply submitted', action.communitySlug);
      break;
    case 'FOLLOW_POST_SUCCESS':
      trackEvent('Activity', 'Followed post', action.trackLabel);
      break;
    case 'FOLLOW_COMMUNITY_SUCCESS':
      trackEvent('Activity', 'Community followed', action.groupCode);
      break;
    case 'SIGN_UP_SUCCESS':
      const {element, section} = action.signupContext;
      // TODO: make Type and Template work for social signup and other types of page
      // [Action: Branch;Type (HU, FB, GO);Element;Template(COMMUNITY, USER, ENTITY);Section]
      const signupAction = getBranch() + ';' + 'HU' + ';' + element + ';' + 'COMMUNITY' + ';' + section;
      const signupUrl = window.location.pathname;
      // the current session doesn't have a membershipId so in order to update it we need to clear the current one
      clearTrackingSession();
      trackEvent('NewAccount', signupAction, signupUrl);
      trackFootfallEvent(footfallEventTypes.SIGNED_UP);
      trackEvent('Account', `Created (${window.HU_TEST_BRANCH})`);
      trackAccountCreatedEvent(`Created (${window.HU_TEST_BRANCH})`);
      trackEventForPartner(state.context.currentCommunity, 'Account', 'Created');
      break;
    default:
      break;
  }
  return result;
};
